import { useState } from 'react'
import { NextSeo } from 'next-seo'
import AnalyticsTrigger from '../components/atoms/AnalyticsTrigger'
import Input from '../components/atoms/Input'
import Textarea from '../components/atoms/Textarea'
import Button from '../components/atoms/Button'
import Buttons from '../components/molecules/Buttons'
import Form from '../components/molecules/Form'
import Layout from '../components/templates/Layout'

const Contact = () => {

  const [contactState, setContactState] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [successful, setSuccessful] = useState(false)

  const handleSubmit = (e: any) => {
    e.preventDefault()
    const email_reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (email_reg.test(contactState.email) && contactState.body) {
      setLoading(true)
      const url = process.env.NEXT_PUBLIC_BACKEND + 'general/contact/';
      let body = JSON.stringify({...contactState});
      const headers = {
        'Content-Type': 'application/json'
      };

      fetch(url, {method: 'POST', headers: headers, body: body})
      .then(() => {
        setSuccessful(true)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false);
      })
    }
  }

  const handleContactChange = (e: any) => {
    const value = e.target.value;
    setContactState({
      ...contactState,
      [e.target.name]: value
    });
  }

  return (
    <Layout>
      <AnalyticsTrigger title={"お問い合わせページ"} />
      <NextSeo title="お問い合わせ - デビクレ" noindex />
      <div className="card">
      <h1>お問い合わせ</h1>
        {successful ? (
          <>お問い合わせありがとうございます。</>
        ):(
          <Form loading={loading} text={"すべてのお問い合わせには返信出来かねる場合がございます、ご了承ください。"}>
            <Input
              name="email"
              type="email"
              label="メールアドレス"
              value={contactState.email}
              onChange={handleContactChange}
              required
            />
            <Textarea
              name="body"
              label="内容"
              value={contactState.body}
              rows={5}
              onChange={handleContactChange}
              required
            />
            <Buttons>
              <Button onClick={(e: any) => handleSubmit(e)}>
                送信
              </Button>
            </Buttons>
          </Form>
        )}
      </div>
    </Layout>
  )
}

export default Contact
